import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'rsuite';
import ReportTemplatesList from '../ReportTemplatesList';

export default class ReportTemplatesModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    templates: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    isFetchingTemplates: PropTypes.bool.isRequired,
    getTempates: PropTypes.func.isRequired,
    onHide: PropTypes.func,
    onSelect: PropTypes.func
  };

  static defaultProps = {
    onHide: () => {},
    onSelect: () => {}
  };

  handleShow = () => {
    const { getTempates } = this.props;
    getTempates();
  };

  handleSelect = item => {
    const { onSelect } = this.props;
    onSelect(item);
  };

  render() {
    const { show, onHide, templates, isFetchingTemplates } = this.props;
    return (
      <Modal
        size="md"
        show={show}
        onHide={onHide}
        overflow
        onShow={this.handleShow}
      >
        <Modal.Header>
          <Modal.Title>Presets</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ReportTemplatesList
            onSelect={this.handleSelect}
            loading={isFetchingTemplates}
            data={templates}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onHide} appearance="subtle">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
